import { useState, useEffect, useContext } from 'react'
import api from 'api'
import DrupalContext from 'contexts/DrupalContext'

const useSuggestions = (userInput) => {
  const drupal = useContext(DrupalContext)
  const [suggestions, setSuggestions] = useState([])
  const [fetchController, setFetchController] = useState()

  useEffect(() => {
    if (!userInput?.length) return setSuggestions([])
    if (fetchController) {
      fetchController.cancel()
      setFetchController(null)
    }

    ;(async () => {
      try {
        const urlParams = { q: userInput }
        const [fetchSuggestions, controller] = api.fetchSuggestions(urlParams, drupal)

        setFetchController(controller)
        const res = await fetchSuggestions
        const { data, config: { baseURL, url, params } = {} } = res || {}

        window.react.suggestions = {
          data,
          request: {
            baseURL,
            url,
            params,
            endpoint: url?.split('/')?.pop(),
          }
        }

        setSuggestions(data?.suggestions || [])
      } catch (e) {
        setSuggestions([])
      }
    })()
  }, [userInput])

  return {
    suggestions,
  }
}

export default useSuggestions
